export const TENURE_OPTIONS = [1, 3, 9, 12, 15];

export const TYPE_OPTIONS = ["Recharge", "New Connection"];

export const formatDateLabel = (value) => {
  if (!value) return "—";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "—";
  return date.toLocaleDateString("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
};

export const formatCurrency = (value) => {
  const amount = Number(value) || 0;
  return `₹ ${amount.toLocaleString("en-IN")}`;
};

export const toDateInputValue = (value = new Date()) => {
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "";
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

export const formatTenureLabel = (months) =>
  months ? `${months} month${Number(months) === 1 ? "" : "s"}` : "—";
